import { ContentComponents } from "@bluframe/blublocks"
import prepareComponent from "@bluframe/grapple/prepareComponent"

import Item from "./Item"
import { Paragraph } from "./styled"

interface Props {
  isMarkdown?: boolean
  isNotLast: boolean
  item: string
}

export interface ComponentProps extends Props {
  components: ContentComponents
}

const usePrepareComponent = (props: Props): ComponentProps => {
  const components: ContentComponents = {
    // eslint-disable-next-line id-length
    p: ({ node, ...restProps }) => <Paragraph {...restProps} />
  }

  return {
    ...props,
    components
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Item
)
